import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, FooterActionBar } from '@saviynt/design-system';

import testIds from '../../../../constants/testIds';
import useLocalization from '../../../../hooks/use-localize';
import Logger from '../../../../services/loggerService';
import { type ConnectionPayload } from '../../data-layer/ApplicationCard';
import { useDiscoverySaveConnectionMutation } from '../../data-layer/ApplicationSlice';
import { resetDiscoverySaveConnectionState } from '../../data-layer/DiscoverySaveConnectionSlice';

import './ExistingConnectionFooter.css';

interface ExistingConnectionFooterProps {
  usingExistingConnection: (value: boolean) => void;
  handleCreateNewConnection: () => void;
  existingConnectionPayload: ConnectionPayload | undefined;
}

/**
 * ExistingConnectionFooter
 */
function ExistingConnectionFooter({
  usingExistingConnection,
  handleCreateNewConnection,
  existingConnectionPayload,
}: ExistingConnectionFooterProps) {
  const formatMessage = useLocalization();
  const [discoverySaveConnection, { isLoading }] =
    useDiscoverySaveConnectionMutation();

  const dispatch = useDispatch();

  const handleUseExisting = () => {
    if (existingConnectionPayload) {
      usingExistingConnection(true);
      dispatch(resetDiscoverySaveConnectionState());

      discoverySaveConnection(existingConnectionPayload).catch((err) => {
        Logger.error(err);
      });
    }
  };

  return (
    <FooterActionBar className='ExistingConnection'>
      <Box className='ExistingConnection-Container'>
        <Button
          dataTestId={
            testIds.DISCOVERY_EXISTING_CONNECTION_CREATE_NEW_CONNECTION
          }
          onClick={handleCreateNewConnection}
          kind='outlined'>
          {formatMessage(
            'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION',
            'Create New Connection'
          )}
        </Button>
        <Button
          dataTestId={testIds.DISCOVERY_EXISTING_CONNECTION_USE_THIS_CONNECTION}
          loaderText={formatMessage('INTEGRATIONS.BUTTON.SAVING', 'Saving')}
          isLoading={isLoading}
          onClick={handleUseExisting}>
          {formatMessage(
            'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION',
            'Use This Connection'
          )}
        </Button>
      </Box>
    </FooterActionBar>
  );
}

export default ExistingConnectionFooter;
